/**
 * Luật thuần của blocklist có hạn (ADR-0090 mục 3): bốn thời hạn chọn được khi chặn tay, và cách nói "còn bao lâu"
 * cho từng dòng. Không phụ thuộc React để test được bằng `node --test`.
 */

/** Thời hạn chọn khi chặn tay. `phut` là số gửi lên ở `duration_minutes`; `null` là vĩnh viễn. */
export const THOI_HAN_CHAN = [
  { ma: '1h', phut: 60 },
  { ma: '24h', phut: 24 * 60 },
  { ma: '7d', phut: 7 * 24 * 60 },
  { ma: 'vinh-vien', phut: null },
] as const;

export type MaThoiHan = (typeof THOI_HAN_CHAN)[number]['ma'];

/** Mặc định 24 giờ: đủ để điều tra, không ai phải nhớ gỡ (ADR-0090 mục 3.1). */
export const THOI_HAN_MAC_DINH: MaThoiHan = '24h';

export function phutCuaThoiHan(ma: MaThoiHan): number | null {
  return THOI_HAN_CHAN.find((t) => t.ma === ma)?.phut ?? null;
}

/**
 * Thời gian còn lại của một dòng, theo bậc dễ đọc:
 * - dưới 1 giờ: số phút, làm tròn lên (còn 30 giây vẫn là "còn 1 phút", không phải "còn 0 phút");
 * - dưới 2 ngày: số giờ, làm tròn xuống ("còn 23 giờ" chứ không "còn 1 ngày" khi chưa đủ);
 * - còn lại: số ngày, làm tròn xuống.
 */
export type ConLai =
  | { loai: 'vinh-vien' }
  | { loai: 'het-han' }
  | { loai: 'phut' | 'gio' | 'ngay'; so: number };

export function conLai(expiresAt: string | null, bayGio: number): ConLai {
  if (!expiresAt) return { loai: 'vinh-vien' };
  const ms = Date.parse(expiresAt) - bayGio;
  if (Number.isNaN(ms) || ms <= 0) return { loai: 'het-han' };
  const phut = Math.ceil(ms / 60_000);
  if (phut < 60) return { loai: 'phut', so: phut };
  const gio = Math.floor(ms / 3_600_000);
  if (gio < 48) return { loai: 'gio', so: gio };
  return { loai: 'ngay', so: Math.floor(ms / 86_400_000) };
}

/** Dòng chặn tự động (đăng nhập sai dồn dập). Bản API cũ không có `source` thì coi là chặn tay. */
export function laTuDong(dong: { source?: string }): boolean {
  return dong.source === 'AUTO';
}
